import { Injectable, Pipe, PipeTransform } from '@angular/core';
//import * as _ from 'lodash';

@Pipe({
 name: 'searchfilter'
})

@Injectable()
export class SearchFilterPipe implements PipeTransform {
 transform(items: any[], arg:{facebook:boolean, instagram: boolean,blog: boolean, advertisement: boolean, autre: boolean}): any[] {

   if (!items) return [];
   if (arg === undefined) {
      return items;
   }
    return items.filter(it => (it.facebook === arg.facebook || it.instagram || arg.instagram || it.blog === arg.blog || it.advertisement === arg.advertisement || it.autre === arg.autre)
  );
 }
}



// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/shared/pipes/searchpipe.directive.ts